import { COLUMN_TYPE, ColumnTypes } from "utils/constants";

export interface SoftwareVersionColumnTypes {
  id: string;
  label: string;
  isSort: boolean;
  width: string;
  type: string;
  align: "center" | "left" | "end" | "justify" | "start";
}

export const SOFTWARE_VERSIONS_GRID_COLUMNS: SoftwareVersionColumnTypes[] = [
  {
    id: "swVersion",
    label: "Version",
    isSort: true,
    width: "200px",
    align: "left",

    type: COLUMN_TYPE.STRING,
  },
  {
    id: "deviceCount",
    label: "Count",
    isSort: true,
    width: "200px",
    align: "center",
    type: COLUMN_TYPE.NUMBER,
  },
];
